export default __webpack_public_path__ + "static/media/eleEng.8de74ce3.jpg";